/**
 * For a sticky header
 */
jQuery(($) => {
  const $header = $('.header');
  const $logo = $('.site-logo');

  if (!$header.length || !$logo.length) return;

  const originalLogo = $logo.attr('src');
  const footerLogo = $logo.data('footer-logo');

  let prevScrollY = $(window).scrollTop();
  let scrollPosition = 0;

  function updateHeader() {
    const currentScrollY = $(window).scrollTop();
    const isScrollingDown = currentScrollY > prevScrollY;

    $header.toggleClass('is-scrolled', currentScrollY > 0);

    // logo switch
    if (currentScrollY === 0) {
      $logo.attr('src', originalLogo);
    } else if (footerLogo) {
      $logo.attr('src', footerLogo);
    }

    // hide/show
    if (currentScrollY > 10 && isScrollingDown) {
      $header.addClass('hidden');
    } else {
      $header.removeClass('hidden');
    }

    prevScrollY = currentScrollY;
  }

  updateHeader();
  $(window).on('scroll', updateHeader);

  // Side menu
  $('.hamburger-icon').on('click', function (e) {
    e.stopPropagation();

    const $body = $('body');

    if (!$body.hasClass('menu-open')) {
      $body.addClass('menu-open');

      // prevent window scroll
      $body.css({
        position: 'fixed',
        width: '100%',
      });
    } else {
      closeMenu();
    }
  });

  function closeMenu() {
    const $body = $('body');

    $body.removeClass('menu-open');

    $body.css({
      position: '',
      width: '',
    });
  }

  // close menu on window click
  $(window).on('click', function () {
    closeMenu();
  });

  // Stop sidebar closing when clicking inside menu
  $('.sidebar-menu').on('click', function (e) {
    e.stopPropagation();
  });

  // Submenu icon keyboard + click
  $('.submenu-icon').on('click keydown', function (e) {
    // stop window/document close
    e.stopPropagation();

    if (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
    }

    const $button = $(this);
    const $parent = $button.closest('.menu-item-has-children');

    $parent.toggleClass('menu-active');
  });

  // Prevent closing when clicking menu item / pseudo area
  $('.mobile-menu .menu-item-has-children').on('click', function (e) {
    const rect = this.getBoundingClientRect();

    const pseudoWidth = 200;
    // Right 32px area (pseudo-element width)
    if (e.clientX > rect.right - pseudoWidth) {
      e.preventDefault();
      e.stopPropagation();
    }

    $(this).toggleClass('menu-active');
  });

  $(document).on('click', () => {
    $('body').removeClass('menu-open');
  });
});
